/**
 * StrategyListItem Component
 *
 * Presentational component for rendering a strategy in a list.
 * Stateless - receives all data and callbacks via props.
 * Presentational component for mobile strategy list.
 */

import React from 'react';

import type { Strategy } from '@/types/schema/Strategy';

export interface StrategyListItemProps {
  strategy: Strategy;
  isSelected: boolean;
  isArchived: boolean;
  onSelect: () => void;
}

export const StrategyListItem: React.FC<StrategyListItemProps> = ({
  strategy,
  isSelected,
  isArchived,
  onSelect,
}) => {
  return (
    <button
      onClick={onSelect}
      className={`w-full min-w-0 text-left px-3 py-2 rounded-md transition-colors ${
        isSelected
          ? 'bg-primary-100 dark:bg-primary-900/30'
          : 'hover:bg-default-100'
      }`}
    >
      <div className="flex items-center w-full min-w-0">
        <span
          className={`min-w-0 flex-1 truncate font-medium text-sm ${
            isArchived ? 'text-text-tertiary' : 'text-text-primary'
          }`}
        >
          {strategy.name}
        </span>
        {isArchived && (
          <span className="ml-2 shrink-0 text-xs text-text-tertiary bg-default-100 px-1.5 py-0.5 rounded">
            Archived
          </span>
        )}
      </div>
    </button>
  );
};
